import { LegalPage } from './LegalPage';

export function ConsentPage() {
  return (
    <LegalPage
      title="Обработка персональных данных"
      subtitle="Согласие на обработку данных, необходимых для юридической помощи. Редакция от 21 октября 2026 года."
    >
      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">1. Кому даётся согласие</h2>
        <p>
          Согласие даётся оператору Сервиса lex.ai. Обработка включает сбор, запись,
          хранение, уточнение, использование, обезличивание, блокирование и удаление данных.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">2. Какие данные</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>имя, фамилия, телефон, email, Telegram ID;</li>
          <li>тексты вопросов и сообщений, комментарии к черновикам;</li>
          <li>файлы и документы, которые вы загружаете;</li>
          <li>сведения о состоянии здоровья, если вы сами указали их в вопросе или документе;</li>
          <li>данные об оплате, тарифе, возвратах и статусах обращения;</li>
          <li>технические данные и cookie, необходимые для работы Сервиса.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">3. Цели обработки</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>регистрация и вход в аккаунт;</li>
          <li>передача вопроса юристу и ведение переписки;</li>
          <li>подготовка ответа, черновиков и плана действий;</li>
          <li>напоминания о сроках и статусах обращения;</li>
          <li>оплата, продление тарифа, возврат средств;</li>
          <li>поддержка, безопасность и улучшение Сервиса.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">4. Действия с данными</h2>
        <p>
          Данные могут обрабатываться автоматизированным и неавтоматизированным способом,
          храниться на серверах в защищённом контуре. Для отправки писем, SMS и уведомлений
          могут привлекаться подрядчики, действующие по поручению оператора.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">5. Срок действия и отзыв</h2>
        <p>
          Согласие действует, пока существует аккаунт и пока данные нужны для обращения.
          Вы можете отозвать согласие, запросив удаление аккаунта в профиле или написав на{' '}
          <a className="font-semibold text-accent" href="mailto:help@lex.ai">help@lex.ai</a>.
          После отзыва конфиденциальные данные удаляются, а обезличенная история обращений
          может сохраняться для аудита и бухгалтерии.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">6. Согласие на медицинские данные</h2>
        <p>
          Если для вопроса нужны сведения о диагнозе, заключении ВВК или состоянии здоровья,
          вы даёте отдельное согласие, отмечая соответствующий пункт при регистрации. Без
          такого согласия юрист может попросить описать ситуацию без медицинских деталей.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">7. Права</h2>
        <p>
          Вы вправе запросить сведения об обработке, исправить данные, ограничить обработку,
          отозвать согласие и обратиться с жалобой в уполномоченный орган. Запросы принимаются
          на <a className="font-semibold text-accent" href="mailto:help@lex.ai">help@lex.ai</a>.
        </p>
      </section>
    </LegalPage>
  );
}
